/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as AppPropTypes from '../../lib/PropTypes';
import Menu from './Menu';
import Button from '../buttons/Button';

import styles from '../../../styles/menus/main-menu.module.scss';

const propTypes = {
    items: AppPropTypes.menuItems,
    opened: PropTypes.bool,
    className: PropTypes.string,
    onItemClick: PropTypes.func,
    onSafeClick: PropTypes.func,
};

const defaultProps = {
    items: null,
    opened: false,
    className: null,
    onItemClick: null,
    onSafeClick: null,
};

const MainMenu = ({ items, opened, className, onItemClick, onSafeClick }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.isOpen]: opened,
            },
        ])}
    >
        <Button className={styles.safe} onClick={onSafeClick} />
        <div className={styles.inner}>
            <div className={styles.innerContent}>
                <Menu
                    items={items}
                    className={styles.menu}
                    itemsClassName={styles.items}
                    itemClassName={styles.item}
                    activeItemClassName={styles.active}
                    linkClassName={styles.link}
                    onClick={onItemClick}
                />
            </div>
        </div>
    </div>
);

MainMenu.propTypes = propTypes;
MainMenu.defaultProps = defaultProps;

export default MainMenu;
